import { AutocompleteWithLabel, InputWithLabel } from '@adotel/components'
import { useQuery } from '@apollo/client'
import { Checkbox, FormControlLabel } from '@material-ui/core'
import React, { useEffect } from 'react'

import { CHANNELS_QUERY } from '../../../graphql/channel'
import { getTranslate } from '../../../localization'
import { Channel } from '../../../types/channel'
import { ContractInput } from '../../../types/contract'

interface ContractDetailsProps {
  contract: ContractInput
  setcontract: (c: ContractInput) => void
}
export const ContractDetails: React.FC<ContractDetailsProps> = ({
  contract,
  setcontract
}) => {
  const { data, loading } = useQuery<{
    channels: Channel[]
  }>(CHANNELS_QUERY)
  useEffect(() => {}, [contract])

  return (
    <div>
      <InputWithLabel
        label={getTranslate('Contract Name')}
        placeholder={getTranslate('Enter Contract Name')}
        autoComplete="off"
        inputSize="small"
        value={contract.Title}
        onChange={(event) =>
          setcontract({ ...contract, Title: event.currentTarget.value })
        }
      />
      <AutocompleteWithLabel
        label={getTranslate('Channel')}
        placeholder={getTranslate('Select Channel')}
        options={
          data?.channels?.map((item) => ({
            label: item.basicDetails.name,
            value: item.basicDetails.channelCode,
            code: item.basicDetails.displayChannelCode
          })) || []
        }
        value={
          !loading
            ? contract.Channels.map((item) => ({
                label:
                  data?.channels.find(
                    (i) =>
                      i.basicDetails.displayChannelCode ===
                      item.DisplayChannelCode
                  )?.basicDetails.name || '',
                value: item.ChannelCode
              }))
            : []
        }
        onChange={(e, v: any) => {
          const selectedChannels: any[] = []
          v.map((value: any) =>
            selectedChannels.push({
              ChannelCode: value.value,
              DisplayChannelCode: value.code,
              CustomerCode: ''
            })
          )
          setcontract({ ...contract, Channels: selectedChannels })
        }}
        multiple
        getOptionSelected={(option, value) => option.value === value.value}
        size="small"
        inputSize="small"
        loading={loading}
        loadingText={getTranslate('Loading') + '...'}
      />
      <FormControlLabel
        label={getTranslate('Enable After Save')}
        control={
          <Checkbox
            defaultChecked
            color="primary"
            checked={contract.Active}
            onChange={(event) =>
              setcontract({ ...contract, Active: event.target.checked })
            }
          />
        }
      />
    </div>
  )
}
